"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const ForgotPasswordLink_1 = __importDefault(require("./ForgotPasswordLink"));
const RegistrationPageLink_1 = require("./RegistrationPageLink");
const Wrapper = styled_components_1.default.div(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign({ display: 'flex', justifyContent: 'space-between' }, theme.auth.b2cLoginLinkWrapper)));
const B2CLoginLinkWrapper = () => {
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(ForgotPasswordLink_1.default, null),
        mobile && react_1.default.createElement(RegistrationPageLink_1.RegistrationPageLink, null)));
};
exports.default = B2CLoginLinkWrapper;
//# sourceMappingURL=B2CLoginLinkWrapper.js.map